const { Observable } = require('rxjs');

function getSymbolObservable() {
  if (typeof Symbol === 'function') {
    return Symbol.observable || Symbol.for('observable');
  }
  return '@@observable';
}

/**
 * Assess whether a given object is an observable.
 * Uses the TC39 Symbol.Observable to make the check
 * @param {any} obj the object to check
 * @returns {boolean} whether the object is an observable
 */
function isObservable(obj) {
  const symbolObservable = getSymbolObservable();
  return obj instanceof Observable || Boolean(obj && obj[symbolObservable])
    // HACK: Use duck-typing to accommodate modules that import their own version of rxjs
    || (Boolean(obj) && (typeof obj.subscribe === 'function'));
}

module.exports = isObservable;
